import React from 'react';

export function Main({ children }) {
  return <main className="App-main">{children}</main>;
}
